export const translations = {
	common: {
		en: async () => import('./translations/en.json'),
		ru: async () => import('./translations/ru.json'),
		uz: async () => import('./translations/uz.json'),
	},
}
export const FALLBACK_LANGUAGE = 'ru'
export { DEFAULT_LANGUAGE, type UserLanguage } from './languages'
export {
	getInitialLanguage,
	normalizeTelegramLanguage,
	resolveInitialLanguage,
} from './language'
export { isUserLanguage } from './languages'

export type TranslationKeys = Awaited<
	ReturnType<typeof translations.common.ru>
>['default']

type Join<K, P> = K extends string
	? P extends string
		? `${K}.${P}`
		: never
	: never

type LeafPaths<T> = T extends object
	? {
			[K in keyof T & string]: T[K] extends object
				? Join<K, LeafPaths<T[K]>>
				: K
		}[keyof T & string]
	: never

type ObjectPaths<T> = T extends object
	? {
			[K in keyof T & string]: T[K] extends object
				? K | Join<K, ObjectPaths<T[K]>>
				: never
		}[keyof T & string]
	: never

export type TranslationPaths = LeafPaths<TranslationKeys>
export type TranslationPrefixes = ObjectPaths<TranslationKeys>

export type TranslationPathValue<T, P extends string> = P extends `${infer K}.${infer Rest}`
	? K extends keyof T
		? T[K] extends object
			? TranslationPathValue<T[K], Rest>
			: never
		: never
	: P extends keyof T
		? T[P]
		: never

export {
	useTranslate,
	type TranslationFunction,
	type ColumnTranslationFunction,
} from './utils/useTranslate'
export {
	useTranslateInitializer,
	translate,
} from './utils/getTranslationFunction'
